import { GET_SURID_DETAILS_REQUEST, GET_SURID_DETAILS_SUCCESS, GET_SURID_DETAILS_FAILURE } from "./actions";

const initialState = {
    // { surId, dataObjectId, schemaId, dataSetId, createdDate, active, xrefs: [], history: [] }
    details: null,
    loading: false,
    getDetailsResult: { success: true },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SURID_DETAILS_REQUEST:
            return { ...state, loading: true, details: null };
        case GET_SURID_DETAILS_SUCCESS:
            return { ...state, loading: false, details: action.payload, getDetailsResult: { success: true } };
        case GET_SURID_DETAILS_FAILURE:
            return { ...state, loading: false, getDetailsResult: { success: false, ...action.payload } };
        default:
            return state;
    }
};
